"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LensDownstreamOwnersQueryGrid = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var LensDownstreamOwnersQueryGql_1 = require("../../queries/LensDownstreamOwnersQueryGql");
var OwnersDisplayGrid_1 = require("../sharedDisplayGrid/OwnersDisplayGrid");
function selectConnectionListResult(resultData) {
    return (resultData === null || resultData === void 0 ? void 0 : resultData.lenses) && resultData.lenses[0] &&
        resultData.lenses[0].downstreamOwnersConnection;
}
function mapResultNode(node) {
    return {
        id: node.vizportalId,
        name: node.name,
        username: node.username,
        domain: node.domain,
        workbookCount: node.ownedWorkbooksConnection ? node.ownedWorkbooksConnection.totalCount : null,
        datasourceCount: node.ownedDatasourcesConnection ? node.ownedDatasourcesConnection.totalCount : null,
        metricsCount: node.ownedMetricsConnection ? node.ownedMetricsConnection.totalCount : null,
        virtualConnectionsCount: node.ownedVirtualConnectionsConnection ? node.ownedVirtualConnectionsConnection.totalCount : null
    };
}
function LensDownstreamOwnersQueryGrid(props) {
    var emptyGridMessage = Localize_1.Messages.EmptyDownstreamOwnersLineageGridMessage();
    return React.createElement(data_catalog_shared_1.PaginatedQueryWrapper, { queryGql: LensDownstreamOwnersQueryGql_1.LensDownstreamOwnersQueryGql, partialQueryVariables: { vizportalUrlId: props.vizportalUrlId, orderBy: props.orderBy }, selectConnectionListResult: selectConnectionListResult, mapResultNode: mapResultNode }, function (_a) {
        var rowStore = _a.rowStore;
        return (React.createElement(OwnersDisplayGrid_1.OwnersDisplayGrid, { rowStore: rowStore, selectedKeys: props.selectedKeys, updateSelectionForKey: props.updateSelectionForKey, emptyGridMessage: emptyGridMessage, rowCount: props.rowCount, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }));
    });
}
exports.LensDownstreamOwnersQueryGrid = LensDownstreamOwnersQueryGrid;
//# sourceMappingURL=LensDownstreamOwnersQueryGrid.js.map